export enum TitleStatus {
  clean = 'clean',
  lien = 'lien',
  rebuilt = 'rebuilt',
  salvage = 'salvage',
  parts = 'parts',
  missing = 'missing',
}

export const TitleStatusValues: { [key in TitleStatus]: string } = {
  clean: 'Clean',
  lien: 'Lien',
  rebuilt: 'Rebuilt',
  salvage: 'Salvage',
  parts: 'Parts',
  missing: 'Missing',
};
